import * as components from './components'

export default [
  {
    path: '/documents',
    component: components.Documents,
    name: 'documents'
  },
  {
    path: '/documents/order/:docId',
    component: components.RashodnayaNakladnaya,
    name: 'documents/rashodnayanakladnaya'
  },
  {
    path: '/documents/schet/:docId',
    component: components.Schet,
    name: 'documents/schet'
  },
  {
    path: '/documents/rezervirovanie/:docId',
    component: components.Rezervirovanie,
    name: 'documents/rezervirovanie'
  }
]
